import React from "react";
import "./css/style.css";
import moment from "moment";
import Cookies from "universal-cookie";
import getSessioniLezione from "../services/getSessioniLezione";

export default class ScheduleView extends React.Component {
  constructor() {
    super();
    this.meetings = [];
    this.scheduleRef = React.createRef();

    this.start = 0;
    this.state = {
      popupVisible: false,
      x: 0,
      y: 0,
      sessioniPerLezione: {}, // Cache delle sessioni per ogni lezione
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.currentEventStartHour = 8;
    this.currentEventStartMinutes = 0;
    this.currentEventEndHour = 22;
    this.currentEventEndMinutes = 0;

    this.timePrecision = this.props.timePrecision;
    this.timeDivisor = 60 / this.timePrecision;

    this.labelsTime = [];
    for (
      var i = parseInt(this.currentEventStartHour) + 1;
      i < parseInt(this.currentEventEndHour);
      i++
    ) {
      let label = i + ":00";
      let position =
        this.currentEventStartMinutes / 60 +
        (i -
          parseInt(this.currentEventStartHour) -
          (this.currentEventStartMinutes > 0 ? 1 : 0));
      this.labelsTime.push({
        label: label,
        position: position,
      });
    }

    this.meetings = this.props.meeting;
    this.breaks = this.props.breaks;
    this.date = this.props.date;
    this.type = this.props.type;
    this.subject = this.props.subject;

    let endTimestamp =
      parseInt(this.currentEventEndHour) * 60 +
      parseInt(this.currentEventEndMinutes);
    let startTimestamp =
      parseInt(this.currentEventStartHour) * 60 +
      parseInt(this.currentEventStartMinutes);

    this.hoursCount = (endTimestamp - startTimestamp) / 60;
    let percentageSlot = 100 / this.hoursCount;
    this.slotSize = percentageSlot / this.timeDivisor;

    // Carica le sessioni per le lezioni
    if (username && token) {
      await this.loadSessioniLezioni(username, token);
    }

    this.setState({});
  }

  async componentDidUpdate(prevProps) {
    // Ricarica le sessioni se le lezioni cambiano
    if (prevProps.lezioni !== this.props.lezioni) {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });
      if (username && token) {
        await this.loadSessioniLezioni(username, token);
      }
    }
  }

  async loadSessioniLezioni(username, token) {
    const lezioni = this.props.lezioni || [];
    const sessioniPerLezione = {};

    // Carica le sessioni per ogni lezione in parallelo
    const promises = lezioni.map(async (lezione) => {
      try {
        const sessioni = await getSessioniLezione(username, token, lezione.id);
        if (sessioni && sessioni.length > 0) {
          sessioniPerLezione[lezione.id] = sessioni;
        }
      } catch (error) {
        console.error(
          `Errore caricamento sessioni per lezione ${lezione.id}:`,
          error
        );
      }
    });

    await Promise.all(promises);
    this.setState({ sessioniPerLezione });
  }

  getInsegnantiMaterie(lezione) {
    const sessioni = this.state.sessioniPerLezione[lezione.id] || [];
    const haSessioni = sessioni.length > 0;

    let nomiInsegnanti = [];
    let nomiMaterie = [];

    if (haSessioni) {
      // Lezione divisa in sessioni - raccoglie info da tutte le sessioni
      const sessioniOrdinate = sessioni.sort((a, b) => a.ordine - b.ordine);

      sessioniOrdinate.forEach((sessione, index) => {
        // Insegnanti della sessione
        const idInsegnanti = (sessione.id_insegnanti || "")
          .split(",")
          .filter((id) => id.trim());
        const insegnantiSessione = this.props.insegnanti.filter((insegnante) =>
          idInsegnanti.includes(insegnante.id.toString())
        );

        // Materie della sessione
        const idMaterie = (sessione.id_materia || "")
          .split(",")
          .filter((id) => id.trim());
        const materieSessione = this.props.materie.filter((materia) =>
          idMaterie.includes(materia.id.toString())
        );

        // Aggiungi con label della sessione
        const labelSessione = sessione.ordine === 1 ? "1ª" : "2ª";
        insegnantiSessione.forEach((ins) => {
          nomiInsegnanti.push({
            nome: ins.nome,
            cognome: ins.cognome,
            label: labelSessione,
          });
        });
        materieSessione.forEach((mat) => {
          nomiMaterie.push({
            materia: mat.materia,
            label: labelSessione,
          });
        });
      });
    } else {
      // Lezione intera - usa i dati della lezione principale
      const idInsegnanti = (lezione.id_insegnanti || "")
        .split(",")
        .filter((id) => id.trim());
      const insegnantiSelezionati = this.props.insegnanti.filter((insegnante) =>
        idInsegnanti.includes(insegnante.id.toString())
      );
      nomiInsegnanti = insegnantiSelezionati.map((insegnante) => ({
        nome: insegnante.nome,
        cognome: insegnante.cognome,
        label: null,
      }));

      const idMaterie = (lezione.id_materia || "")
        .split(",")
        .filter((id) => id.trim());
      const materiaSelezionata = this.props.materie.filter((materia) =>
        idMaterie.includes(materia.id.toString())
      );
      nomiMaterie = materiaSelezionata.map((materia) => ({
        materia: materia.materia,
        label: null,
      }));
    }

    return { nomiInsegnanti, nomiMaterie, haSessioni };
  }

  _onMouseClick(e) {
    let currentSlot = this.state.currentSlot;
    var hours =
      Math.trunc(currentSlot / this.timeDivisor) +
      parseInt(this.currentEventStartHour);
    var minutes =
      (currentSlot % this.timeDivisor) * this.timePrecision +
      parseInt(this.currentEventStartMinutes);
    if (minutes >= 60) {
      hours = hours + 1;
      minutes = minutes - 60;
    }

    let date = moment(parseInt(hours) + ":" + parseInt(minutes), "hh:mm");
    let timeSlot = moment(date).format("HH:mm");
    let dateSlot = this.date;

    this.props.onMouseClick(dateSlot, timeSlot);
  }

  _onMouseEnter(e) {
    this.setState({ popupVisible: true });
  }

  _onMouseLeave(e) {
    this.setState({ popupVisible: false });
  }

  _onMouseMove(e) {
    let boundingBox = this.scheduleRef.current.getBoundingClientRect();
    this.start = boundingBox.left;
    this.top = e.screenY - boundingBox.top - boundingBox.height;
    let width = boundingBox.width;
    let slotWidth = width / this.hoursCount / this.timeDivisor;
    let currentSlot = Math.trunc(
      (e.clientX - this.start + slotWidth / 2) / slotWidth
    );
    this.setState({
      popupVisible: true,
      currentSlot: currentSlot,
      x: (e.clientX - this.start) / width,
      mouseX: e.clientX,
      mouseY: e.clientY,
    });
  }

  render() {
    if (this.subject == undefined) return null;

    let currentSlot = this.state.currentSlot;
    let hours =
      Math.trunc(currentSlot / this.timeDivisor) +
      parseInt(this.currentEventStartHour);
    let minutes =
      (currentSlot % this.timeDivisor) * this.timePrecision +
      parseInt(this.currentEventStartMinutes);
    if (minutes >= 60) {
      hours = hours + 1;
      minutes = minutes - 60;
    }

    let date = moment(parseInt(hours) + ":" + parseInt(minutes), "hh:mm");
    let timeSlot = moment(date).format("HH:mm");

    return (
      <div className="mainContainer">
        {this.labelsTime &&
          this.labelsTime.map((v) => {
            return (
              <div
                className="timeLbl"
                style={{
                  left:
                    String(this.slotSize * this.timeDivisor * v.position) + "%",
                }}
              >
                | {v.label}
              </div>
            );
          })}
        <div
          ref={this.scheduleRef}
          className="mainClass"
          onMouseMove={this._onMouseMove.bind(this)}
          onMouseEnter={this._onMouseEnter.bind(this)}
          onMouseLeave={this._onMouseLeave.bind(this)}
          onClick={this._onMouseClick.bind(this)}
        >
          {this.props.lezioni &&
            this.props.lezioni.map((lezione) => {
              var dd = lezione.data.split(" ")[0];
              var time = lezione.data.split(" ")[1].split(":");
              var hh = time[0];
              var mm = time[1];

              if (dd != this.date) return null;

              let startMeeting =
                (parseInt(hh) - parseInt(this.currentEventStartHour)) *
                this.timeDivisor;
              startMeeting =
                startMeeting +
                parseInt(mm) / this.timePrecision -
                parseInt(this.currentEventStartMinutes) / this.timePrecision;

              // Usa il metodo che gestisce le sessioni
              const {
                nomiInsegnanti,
                nomiMaterie,
                haSessioni,
              } = this.getInsegnantiMaterie(lezione);

              return (
                <SlotElem
                  key={lezione.id}
                  start={startMeeting}
                  duration={parseInt(lezione.durata / this.timePrecision)}
                  slotSize={this.slotSize}
                  parent={this}
                  materia={nomiMaterie}
                  nomiInsegnanti={nomiInsegnanti}
                  insegnanti={this.props.insegnanti}
                  subject={this.subject}
                  meeting={lezione}
                  haSessioni={haSessioni}
                />
              );
            })}
        </div>
        <div
          className="popupSchedule"
          key={Math.random()}
          style={{
            display: this.state.popupVisible ? "block" : "none",
            left: this.state.mouseX - this.start,
            top: this.top,
          }}
        >
          {timeSlot}
        </div>
      </div>
    );
  }
}

function SlotElem(props) {
  const { haSessioni, nomiInsegnanti, materia } = props;

  return (
    <div
      className={"slotClass"}
      style={{
        left: String(props.slotSize * props.start) + "%",
        width: String(props.slotSize * props.duration) + "%",
        backgroundColor: haSessioni ? "#e8f4e8" : undefined, // Verde chiaro per sessioni
        border: haSessioni ? "1px solid #28a745" : undefined,
      }}
    >
      {nomiInsegnanti && nomiInsegnanti.length > 0 && (
        <div>
          {haSessioni ? (
            // Visualizzazione per sessioni
            nomiInsegnanti.map((insegnante, idx) => (
              <p
                key={idx}
                style={{
                  fontWeight: "bold",
                  fontSize: "11px",
                  color: "#333",
                  margin: "2px 0",
                }}
              >
                {insegnante.label ? `${insegnante.label}: ` : ""}
                {insegnante.nome} {insegnante.cognome}
              </p>
            ))
          ) : (
            // Visualizzazione per lezione intera
            <p style={{ fontWeight: "bold", fontSize: "12px", color: "#333" }}>
              {nomiInsegnanti
                .map((insegnante) => insegnante.nome + " " + insegnante.cognome)
                .join(", ")}
            </p>
          )}
        </div>
      )}
      {materia && materia.length > 0 ? (
        <div style={{ marginTop: "2px" }}>
          {haSessioni ? (
            // Visualizzazione per sessioni
            materia.map((mat, idx) => (
              <p
                key={idx}
                style={{ fontSize: "10px", color: "#555", margin: "1px 0" }}
              >
                {mat.label ? `${mat.label}: ` : ""}
                {mat.materia || mat}
              </p>
            ))
          ) : (
            // Visualizzazione per lezione intera
            <p style={{ fontSize: "10px", color: "#555" }}>
              {materia.map((m) => m.materia || m).join(", ")}
            </p>
          )}
        </div>
      ) : (
        <div style={{ marginTop: "2px" }}>
          <p style={{ fontSize: "10px", color: "#555" }}>Lezione</p>
        </div>
      )}
      {haSessioni && (
        <span
          style={{ fontSize: "9px", color: "#28a745", fontStyle: "italic" }}
        >
          (Divisa)
        </span>
      )}
    </div>
  );
}
